import { useTranslation } from 'react-i18next';

import { useSnackbarContext } from 'pages/ParentHelper/providers/SnackbarProvider/hooks';
import { Divider } from 'shared/components/Divider';
import { Snackbar } from 'shared/components/Snackbar';

import { Body } from './components/Body';
import { Footer } from './components/Footer';
import { Header } from './components/Header';
import { SnackbarCloseButton } from './components/SnackbarCloseButton';
import { Wrapper } from './components/Wrapper';

import type { FC } from 'react';

export const Chat: FC = () => {
  const { t } = useTranslation();
  const { isFeedbackOpened, onClose: onCloseSnackbar } = useSnackbarContext();

  return (
    <Wrapper>
      <Header />
      <Divider />
      <Body />
      <Footer />
      <Snackbar
        open={isFeedbackOpened}
        message={t('pages.parentHelper.chat.body.dislikeSnackbar.message')}
        onClose={onCloseSnackbar}
        action={<SnackbarCloseButton />}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      />
    </Wrapper>
  );
};
